module.exports = __webpack_public_path__ + "img/kr-purchase-banner.3bf45bb2.png";